'use client';

import { useFormContext } from 'react-hook-form';
import { useLanguage } from '../../../../../context/LanguageContext';

export default function SellerStep6BankDetails() {
  const { register, formState: { errors, touchedFields, isSubmitted } } = useFormContext();
  const { translate } = useLanguage();

  return (
    <div className="space-y-6">
      <div className='text-center'>
        <h2 className="text-2xl font-bold text-white mb-2">
          {translate("auth.signup.bankDetails")}
        </h2>
        <p className="text-white">
          {translate("auth.signup.enterBankingInformation")}
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="bankName" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.bankName")}
          </label>
          <input
            {...register('bankName')}
            id="bankName"
            type="text"
            placeholder={translate("auth.signup.bankNamePlaceholder")}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.bankName || isSubmitted) && errors.bankName && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.bankName.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="accountHolderName" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.accountHolderName")}
          </label>
          <input
            {...register('accountHolderName')}
            id="accountHolderName"
            type="text"
            placeholder={translate("auth.signup.accountHolderNamePlaceholder")}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.accountHolderName || isSubmitted) && errors.accountHolderName && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.accountHolderName.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="accountNumber" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.accountNumber")}
          </label>
          <input
            {...register('accountNumber')}
            id="accountNumber"
            type="text"
            placeholder={translate("auth.signup.accountNumberPlaceholder")}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.accountNumber || isSubmitted) && errors.accountNumber && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.accountNumber.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="iban" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.iban")}
          </label>
          <input
            {...register('iban')}
            id="iban"
            type="text"

            placeholder={translate("auth.signup.ibanPlaceholder")}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.iban || isSubmitted) && errors.iban && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.iban.message)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
